(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var menuBtn = document.getElementById('wistyMenuBtn');
    var nav = document.getElementById('wistyNav');
    var closeBtn = document.getElementById('wistyNavClose');
    if (!menuBtn || !nav) return;

    var CLOSE_MS = 420;

    function openNav() {
      nav.classList.add('wnav--open');
      document.body.classList.add('wnav-lock');
    }
    function closeNav() {
      nav.classList.remove('wnav--open');
      document.body.classList.remove('wnav-lock');
    }

    menuBtn.addEventListener('click', openNav);
    menuBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openNav();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('wnav--open')) closeNav();
    });

    // Ссылки-якоря (#section-id): закрываем шторку, ждём, пока она уедет, потом плавно скроллим
    nav.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = link.getAttribute('href').slice(1);
        var target = document.getElementById(targetId);
        closeNav();
        if (target) {
          setTimeout(function () {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, CLOSE_MS);
        }
      });
    });

    // Обычные ссылки (mailto и т.д.) — просто закрываем шторку, дальше браузер сам всё сделает
    nav.querySelectorAll('a:not([href^="#"])').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
  });
})();